import React from 'react';
import Background from "../../assets/images/background/banner.jpg";
import { Link } from 'react-router-dom';

import './odoo.css';
import Service from './service';
import About from "./about";
import About1 from './about1';
import Service1 from './service1';
import Choose from './choose';
import Process from './process';
import Call from './call';
import Test from './testi';
import Faq from './faq';
import Test2 from './testi2';
import Testimonial from '../Home/testimonial';
import SEO from '../seo';

export default function Odoo() {
      const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ];  
    return (
        <div>
              <SEO
                title="Odoo"
                description="Entrepreneur &amp; Managing Director Mr. Nilesh Parmar Nilesh Parmar is a dynamic entrepreneur and the driving force behind Horizon Webinfo Pvt Ltd, a leading IT solutions company that has been revolutionizing the digital landscape since its inception. Entrepreneurial Vision: With an unwavering passion for technology and innovation, Nilesh founded Horizon Webinfo Pvt Ltd in Mr. [&hellip;]"
                canonical="https://www.hwplindia.com/odoo/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2023/12/nilesh-parmar-img.jpg"
                keywords={pageKeywords}
            />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Odoo</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Odoo</li>
                    </ul>
                </div>
            </section>
            <About1 />
            <Service1 />
             <Process />
            <Choose />
           
            {/* <Call /> */}
            <Testimonial />
            <Faq />
        </div>
    );
}